'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiFlag = function TiFlag(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.6 7.2c-0.6-0.3-1.3-0.1-1.8 0.4-2.1 2.1-5.5 2.1-7.6 0-3.4-3.4-9-3.4-12.4 0-0.3 0.3-0.5 0.7-0.5 1.1v21.7c0 0.9 0.8 1.7 1.7 1.7s1.7-0.8 1.7-1.7v-7.6c2.1-1.6 5.2-1.5 7.1 0.4 3.4 3.5 9 3.5 12.4 0 0.3-0.3 0.5-0.7 0.5-1.1v-13.4c0-0.6-0.4-1.2-1.1-1.5z' })
        )
    );
};

exports.default = TiFlag;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/flag.js
// module id = 1888
// module chunks = 0